import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/toaster";
import CursorGlow from "./components/ui/cursor-glow";
import PandaFollower from "./components/ui/panda-follower";
import AnimatedBackground from "./components/AnimatedBackground";

function App() {
  return (
    <div className="App">
      <AnimatedBackground />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      <CursorGlow />
      <PandaFollower />
    </div>
  );
}

export default App;
